/**
 * What a mould's QR carries: a link to the mould itself.
 *
 * `<site>/m/<mould id>` - the same as the engraved plate. A phone camera opens
 * the mould's page (after signing in); the in-app scanner reads the id off the
 * end. The id is the database's own and never changes, unlike a name or even
 * a code. Labels printed before this carry the bare code, and the scanner still
 * takes that.
 *
 * The site is the API's own address - not this page's, which inside the
 * Android app is https://localhost - unless VITE_QR_BASE_URL says otherwise.
 */
const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

export function qrBase(): string {
  const configured = import.meta.env.VITE_QR_BASE_URL as string | undefined;
  if (configured) return configured.replace(/\/+$/, '');
  return new URL(API_BASE, window.location.href).origin;
}

export function mouldQrValue(mould: { id: string }): string {
  return `${qrBase()}/m/${encodeURIComponent(mould.id)}`;
}
